import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import SegmentedControl from "legacy/SegmentedControl"
import { centsToDollars, humanize, parseJSONError } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class SaleRefundModal extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      paymentType: this.props.sale.paymentType || "cash",
      checkNumber: "",
      showModal: false,
      processing: false,
      errorMessage: null,
      formError: null,
    }
    this.setPaymentType = this.setPaymentType.bind(this)
    this.handleRefund = this.handleRefund.bind(this)
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.renderBody = this.renderBody.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sale !== this.props.sale) {
      this.setState({ paymentType: this.props.sale.paymentType || "cash" })
    }
  }

  openModal() {
    this.setState({ showModal: true })
  }

  closeModal() {
    this.setState({ showModal: false, formError: null, errorMessage: null })
  }

  handleRefund() {
    this.setState({ processing: true })
    const params = {
      payment_type: this.state.paymentType,
    }
    if (this.state.checkNumber !== "") {
      params.check_number = this.state.checkNumber
    }
    // Note: jQuery ($) is loaded globally
    $.post(
      this.props.refundEndpoint,
      params,
      (data) => {
        // Note: Amplitude is loaded globally
        Amplitude.trackEvent("web_pos:refund_full", {
          sale_id: this.props.sale.id,
        })
        this.props.handleSuccess(data)
      },
      "json"
    ).fail((data) => {
      const errorMessage =
        parseJSONError(data.responseText) ||
        "Something went wrong while trying to process this refund. Please try again or contact support."
      this.setState({
        processing: false,
        errorMessage,
      })
    })
  }

  setPaymentType(paymentType) {
    this.setState({ paymentType })
  }

  renderBody() {
    if (this.props.sale.status === "refunded") {
      return (
        <p>
          This sale has already been refunded. If you believe this is an error
          please contact support.
        </p>
      )
    }

    if (this.props.sale.paymentType === "credit") {
      return (
        <div>
          <p>Original Payment Method: Credit Card</p>
          <p>{this.props.sale.card.cardDescription}</p>
          <p className="mt-2 text-red-600">{this.state.refundErrorMessage}</p>
        </div>
      )
    } else {
      return (
        <div>
          <p>
            Original Payment Method:{" "}
            {this.props.sale.paymentType &&
              humanize(this.props.sale.paymentType)}
          </p>
          <h3 className="text-sm font-bold">Refund Method:</h3>
          <div className="flex w-48 justify-start">
            <SegmentedControl
              style="teal"
              segments={[
                { id: "cash", title: "Cash" },
                { id: "check", title: "Check" },
              ]}
              handleSelection={this.setPaymentType}
              selectedSegment={this.state.paymentType || "cash"}
            />
          </div>
          {this.state.paymentType === "cash" && (
            <p>
              Make sure to give {centsToDollars(this.props.sale.totalPrice)} in
              cash to the customer.
            </p>
          )}
          {this.state.paymentType === "check" && (
            <FormGroup
              name="checkNumber"
              label="Check Number"
              value={this.state.checkNumber}
              onChange={this.handleInputChange}
            />
          )}
        </div>
      )
    }
  }

  render() {
    return (
      <div className={`w-16 ${this.props.buttonClasses}`}>
        <button
          type="button"
          className="btn btn-secondary m-0"
          onClick={this.openModal}
        >
          Refund
        </button>
        <Modal
          isOpen={this.state.showModal}
          onClose={this.closeModal}
          size="mediumFixed"
        >
          <Modal.Header title="Refund Sale" />
          <Modal.Body>
            <div className="flex-row">
              {this.renderBody()}
              {this.state.errorMessage && (
                <p className="text-red-600">{this.state.errorMessage}</p>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer
            cancelBtnText="Cancel"
            confirmBtnText={`Refund ${centsToDollars(
              this.props.sale.totalPrice
            )}`}
            confirmBtnLoading={this.state.processing}
            onClose={this.closeModal}
            onSubmit={this.handleRefund}
          />
        </Modal>
      </div>
    )
  }
}

SaleRefundModal.propTypes = {
  sale: PropTypes.shape({
    id: PropTypes.string.isRequired,
    paymentType: PropTypes.string,
    status: PropTypes.string,
    totalPrice: PropTypes.number.isRequired,
    card: PropTypes.shape({
      cardDescription: PropTypes.string,
    }),
  }).isRequired,
  refundEndpoint: PropTypes.string.isRequired,
  handleSuccess: PropTypes.func.isRequired,
  buttonClasses: PropTypes.string,
}

SaleRefundModal.defaultProps = {
  buttonClasses: "",
  // We can't provide a default for sale since it's required
  // Instead, we'll handle it in the component logic
}

export default SaleRefundModal
